import { useQuery } from '@apollo/client/react';
import { Box, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { useSearchParams } from 'react-router';

import ListPaginator from '../../../components/List/ListPaginator/ListPaginator';
import type { Gec_Events } from '../../../gql/graphql';
import { GET_FILTERED_EVENTS } from '../../../graphql/queries';
import { eachDayOfInterval } from '../../../helpers/datePickerRangeUtils/datePickerRangeUtils';
import { groupEventsByDay } from '../../../helpers/groupEventsByDay/groupEventsByDay';
import useBuildGraphQLVariables from '../../../hooks/useBuildGraphQLVariables/useBuildGraphQLVariables';
import useParseEvents from '../../../hooks/useParseEvents/useParseEvents';

export default function ListContainer() {
  const [urlFilters] = useSearchParams();
  const filteredData = useBuildGraphQLVariables();
  const { data, loading } = useQuery(GET_FILTERED_EVENTS, {
    variables: { filters: filteredData },
  });
  const events = useParseEvents(data?.gec_events as Gec_Events[]);
  const theme = useTheme();
  let filterDates: string[] = [];
  if (urlFilters.get('startDate') || urlFilters.get('endDate')) {
    const startDate = urlFilters.get('startDate')
      ? dayjs(urlFilters.get('startDate'))
      : dayjs(urlFilters.get('endDate')).subtract(1, 'year');
    const endDate = urlFilters.get('endDate')
      ? dayjs(urlFilters.get('endDate'))
      : dayjs(urlFilters.get('startDate')).add(1, 'year');
    filterDates = eachDayOfInterval(startDate, endDate);
  }
  const groupedEvents = groupEventsByDay(events, filterDates);
  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        marginLeft: '8px',
        height: '100%',
        width: '100%',
        '@media (max-width: 865px)': {
          marginLeft: 0,
        },
      }}
    >
      <ListPaginator events={groupedEvents} loading={loading} />
    </Box>
  );
}
